import loadable from '@loadable/component';

export const ApplicationSummaryPageLoadable = loadable(
  () => import('./ApplicationSummaryPage'),
  { resolveComponent: (module) => module.ApplicationSummaryPage },
);
